import React from 'react';

/**
 * OrnateDivider — a golden horizontal rule with a diamond/lotus motif centerpiece.
 * Use as a section separator throughout the site.
 *
 * Props:
 *  - label (optional string): small Cinzel caption rendered beside the motif.
 *  - variant: 'diamond' (default) | 'lotus'
 */
const OrnateDivider = ({ label, variant = 'diamond', className = '' }) => {
  const Motif = () => {
    if (variant === 'lotus') {
      return (
        <svg
          width="28"
          height="28"
          viewBox="0 0 40 40"
          className="shrink-0"
          aria-hidden="true"
        >
          <g fill="none" stroke="rgba(212,168,67,0.85)" strokeWidth="1.2" strokeLinecap="round">
            <path d="M20 6 C14 14, 14 22, 20 30 C26 22, 26 14, 20 6 Z" />
            <path d="M6 20 C14 14, 22 14, 30 20 C22 26, 14 26, 6 20 Z" />
            <circle cx="20" cy="20" r="2.5" fill="rgba(212,168,67,0.9)" stroke="none" />
          </g>
        </svg>
      );
    }
    // diamond (default)
    return (
      <span
        className="inline-block"
        style={{
          width: 18,
          height: 18,
          transform: 'rotate(45deg)',
          border: '1px solid rgba(212,168,67,0.75)',
          background:
            'radial-gradient(circle at center, rgba(212,168,67,0.55) 0%, transparent 60%), rgba(42,18,5,0.9)',
          boxShadow: '0 0 12px rgba(212,168,67,0.35)',
          position: 'relative',
        }}
      >
        <span
          className="block"
          style={{
            position: 'absolute',
            inset: 4,
            border: '1px solid rgba(212,168,67,0.5)',
          }}
        />
      </span>
    );
  };

  return (
    <div
      className={`ornate-divider ${className}`}
      role="separator"
      aria-label={label || 'section divider'}
      data-testid="ornate-divider"
    >
      <Motif />
      {label ? (
        <span className="text-xs tracking-[0.35em] uppercase text-primary/80 font-heading">
          {label}
        </span>
      ) : null}
      <Motif />
    </div>
  );
};

export default OrnateDivider;
